import { useWrappedRecoilValue } from '../../hooks/useWrappedRecoilValue'
import { runningProgrammeSelector } from '../programmes/programmes.selectors'

export const useFetchRunningProgramme = () => {
  return useWrappedRecoilValue(runningProgrammeSelector)
}
